<template>
	<div
		role="checkbox"
		tabindex="0"
		:aria-checked="selected"
		class="relative inline-block flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus-visible:ring focus-visible:ring-offset-2 focus-visible:ring-blue-800 focus-visible:ring-2"
		:class="[
			look,
			{
				selected: selected,
			},
		]"
		:aria-labelledby="label"
		@keydown.space.prevent="toggleSelected"
		@keydown.enter.prevent="toggleSelected"
		@click="selected = !selected">
		<div
			aria-hidden="true"
			class="inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200"
			:class="{
				'translate-x-5': selected,
				'translate-x-0': !selected,
			}" />
	</div>
</template>

<script lang="ts">
export default {
	props: {
		look: {
			type: String,
			default: "default",
		},
		modelValue: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: "",
		},
	},
	data(): any {
		return {
			selected: false,
		};
	},
	mounted() {
		this.selected = this.modelValue;
	},
	methods: {
		toggleSelected() {
			this.selected = !this.selected; // Update internal state
			// The watcher will emit 'update:modelValue'
		},
	},
	watch: {
		selected(value) {
			this.$emit("update:modelValue", value);
		},
		modelValue(value) {
			this.selected = value;
		},
	},
};
</script>

<style scoped>
.default,
.flag,
.correct {
	@apply bg-gray-500;
}

.default.selected {
	@apply bg-blue-700;
}

.flag.selected {
	@apply bg-red-700;
}

.correct.selected {
	@apply bg-green-700;
}
</style>
